import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useWelcomeKitPageStore } from 'store/pages/welcome-kit-page/pageStore';
import {
  StapleTable,
  StapleTableHeader,
  StapleTableHeading,
  StapleTableRow,
  StapleTableCell,
  Button,
  Tooltip,
} from '@insurancemenu/imenu-components-lib';
import { File } from 'types/policyService';
import { Download } from '@insurancemenu/imenu-components-lib/dist/icons';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { AlignmentTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import {
  DateTableHeadingStyled,
  FileIndexStyled,
  FilesCountStyled,
  TableInfoSectionStyled,
  TotalFilesTextStyled,
  DownloadButtonWrapper,
  StapleTableBodyStyled,
  TriggerButtonStyled,
} from './styles';

const TableRow: React.FC<{ file: File; fileIndex: number }> = observer(({ file, fileIndex }) => {
  function onDownload(): void {
    window.open(`https://${process.env.REACT_APP_API_BASE_URL}/docxBinary/Prod/downloadPdf/${file.id}`, '_blank');
  }
  return (
    <StapleTableRow>
      <StapleTableCell width="90%">
        <FileIndexStyled>{fileIndex + 1}. </FileIndexStyled>
        {file.name}
      </StapleTableCell>
      <StapleTableCell width="10%" onClick={onDownload}>
        <DownloadButtonWrapper>
          <Tooltip label="Download File" alignment={AlignmentTypes.LEFT_CENTER}>
            <Button type="icon" color="primary">
              <Download />
            </Button>
          </Tooltip>
        </DownloadButtonWrapper>
      </StapleTableCell>
    </StapleTableRow>
  );
});

const FilesTable: React.FC = observer(() => {
  const { files, isLoading, getInitialData, triggerAlliedWelcomeLetter } = useWelcomeKitPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <div>
      <TriggerButtonStyled onClick={triggerAlliedWelcomeLetter} color="primary" size="large">
        Trigger Welcome Letter
      </TriggerButtonStyled>
      <TableInfoSectionStyled>
        <TotalFilesTextStyled>
          Total Files:<FilesCountStyled> {files.length} </FilesCountStyled>
        </TotalFilesTextStyled>
      </TableInfoSectionStyled>
      <StapleTable totalElements={files.length} loading={isLoading}>
        <StapleTableHeader>
          <StapleTableRow>
            <StapleTableHeading width="80%">File Name</StapleTableHeading>
            <DateTableHeadingStyled width="4rem">
              Date: {files[0]?.creationDate && normDateToShortAmericanDate(files[0]?.creationDate)}
            </DateTableHeadingStyled>
          </StapleTableRow>
        </StapleTableHeader>
        <StapleTableBodyStyled>
          {files.map((file, index) => (
            <TableRow key={file.id} file={file} fileIndex={index} />
          ))}
        </StapleTableBodyStyled>
      </StapleTable>
    </div>
  );
});

export default FilesTable;
